import { ABORT_ERROR_NAME, AbortError } from './AbortError';

export const isErrorAnAbortError = (error: Error): error is AbortError => error.name === ABORT_ERROR_NAME;

export const isAbortError = (error: unknown): error is AbortError =>
  error instanceof Error && isErrorAnAbortError(error);

export const isErrorButNotAbortError = (error: unknown): error is Error =>
  error instanceof Error && !isErrorAnAbortError(error);
